const SettingsTabPlusSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_7443_26121" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7443_26121)">
        <circle cx="7.99512" cy="8.00293" r="5.50293" stroke="#D5D5D5" />
        <path d="M5.49609 8H10.4961" stroke="#D5D5D5" strokeLinecap="round" />
        <path d="M7.99609 10.5L7.99609 5.5" stroke="#D5D5D5" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export default SettingsTabPlusSvg;
